import { render, staticRenderFns } from "./LaunchPad.vue?vue&type=template&id=a9965b9c&"
import script from "./LaunchPad.vue?vue&type=script&lang=ts&"
export * from "./LaunchPad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports